import React from 'react';
import styled from 'styled-components';
import { Row, Col, Card, Progress } from 'antd';
import { CodeOutlined, GithubOutlined } from '@ant-design/icons';
import ComingSoon from '../components/modules/ComingSoon';

const PageHeader = styled.div`
  background-color: #e6f7ff;
  padding: 3rem 0;
  text-align: center;
`;

const PageTitle = styled.h1`
  font-size: 2.5rem;
  margin-bottom: 1rem;
  color: #0050b3;
`;

const PageDescription = styled.p`
  font-size: 1.1rem;
  max-width: 800px;
  margin: 0 auto;
  color: #666;
`;

const SectionContainer = styled.section`
  padding: 3rem 0;
`;

const SectionTitle = styled.h2`
  margin-bottom: 2rem;
  position: relative;
  
  &:after {
    content: '';
    display: block;
    width: 60px;
    height: 3px;
    background-color: #1890ff;
    margin-top: 0.5rem;
  }
`;

const SkillCard = styled(Card)`
  margin-bottom: 1rem;
  
  .ant-card-head-title {
    font-weight: 500;
  }
`;

const ProjectCard = styled(Card)`
  height: 100%;
  
  .ant-card-cover {
    padding: 1rem 1rem 0;
  }
`;

const ProjectPlaceholder = styled.div`
  background-color: #f0f2f5;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  font-size: 3rem;
  color: #1890ff;
`;

const AiCoding: React.FC = () => {
  const skills = [
    { name: 'Python', percent: 90 },
    { name: 'JavaScript/TypeScript', percent: 85 },
    { name: 'React', percent: 80 },
    { name: 'TensorFlow/PyTorch', percent: 75 },
    { name: '自然语言处理', percent: 70 },
    { name: '计算机视觉', percent: 65 },
  ];

  return (
    <>
      <PageHeader>
        <div className="container">
          <PageTitle>AI编码</PageTitle>
          <PageDescription>
            探索AI辅助编程的前沿技术与应用，提升开发效率与代码质量
          </PageDescription>
        </div>
      </PageHeader>
      
      <SectionContainer>
        <div className="container">
          <SectionTitle>技能展示</SectionTitle>
          <Row gutter={[24, 24]}>
            <Col xs={24} md={12}>
              {skills.slice(0, 3).map((skill) => (
                <SkillCard key={skill.name} title={skill.name}>
                  <Progress percent={skill.percent} status="active" />
                </SkillCard>
              ))}
            </Col>
            <Col xs={24} md={12}>
              {skills.slice(3).map((skill) => (
                <SkillCard key={skill.name} title={skill.name}>
                  <Progress percent={skill.percent} status="active" />
                </SkillCard>
              ))}
            </Col>
          </Row>
        </div>
      </SectionContainer>
      
      <SectionContainer style={{ backgroundColor: '#f5f5f5' }}>
        <div className="container">
          <SectionTitle>项目展示</SectionTitle>
          <Row gutter={[24, 24]}>
            {[1, 2, 3].map((item) => (
              <Col xs={24} md={8} key={item}>
                <ProjectCard
                  cover={
                    <ProjectPlaceholder>
                      <CodeOutlined />
                    </ProjectPlaceholder>
                  }
                  actions={[
                    <GithubOutlined key="github" />,
                  ]}
                >
                  <Card.Meta
                    title={`AI项目 ${item}`}
                    description="项目描述内容正在整理中，敬请期待..."
                  />
                </ProjectCard>
              </Col>
            ))}
          </Row>
        </div>
      </SectionContainer>
      
      <SectionContainer>
        <div className="container">
          <SectionTitle>代码演示</SectionTitle>
          <ComingSoon 
            title="代码演示区" 
            description="交互式代码示例正在开发中，即将上线..." 
          />
        </div>
      </SectionContainer>
    </>
  );
};

export default AiCoding; 